import { transformDateValue } from 'core/js/FormUtils';
export const getStitchingtaskView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let stitchingtaskList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
                            {"fieldLabel":"title","fieldValue":transformDataValue(data.title,"string"), "fieldType":"string"},
                            {"fieldLabel":"Assigned Qty","fieldValue":transformDataValue(data.assignedqty,"number"), "fieldType":"number"},
                            {"fieldLabel":"Received Qty","fieldValue":transformDataValue(data.receivedqty,"number"), "fieldType":"number"},
                            {"fieldLabel":"Task Status Id","fieldValue":transformDataValue(data.taskstatusid,"bodynamiclist"), "fieldType":"bodynamiclist"},
                            {"fieldLabel":"Task Status Name","fieldValue":transformDataValue(data.taskstatusname,"string"), "fieldType":"string"},
                            {"fieldLabel":"orderId","fieldValue":transformDataValue(data.orderid,"ID"), "fieldType":"ID"},
                            {"fieldLabel":"Product Id","fieldValue":transformDataValue(data.productid,"bodynamiclist"), "fieldType":"bodynamiclist"},
                            {"fieldLabel":"Product Order Id","fieldValue":transformDataValue(data.productorderid,"ID"), "fieldType":"ID"},
                            {"fieldLabel":"Worker Id","fieldValue":transformDataValue(data.workerid,"bodynamiclist"), "fieldType":"bodynamiclist"},
                            {"fieldLabel":"Worker Name","fieldValue":transformDataValue(data.workername,"string"), "fieldType":"string"},
                            {"fieldLabel":"Worker Type Id","fieldValue":transformDataValue(data.workertypeid,"number"), "fieldType":"number"},
                            {"fieldLabel":"Stitching Rate","fieldValue":transformDataValue(data.stitchingrate,"double"), "fieldType":"double"},
              
              
            ],
            'dataList': [
                
              ]
          }

          stitchingtaskList.push(card);
  })
  return stitchingtaskList;
}